import information from './additionalFrom/information.vue';
import planList from './additionalFrom/planList.vue';
export default {
  components: {
    information,
    planList
  },
  data() {
    return {
      activeKey: 1,
      id: Number(this.$route.params.id)
    };
  },
  methods: {
    tabChange(val) {
      if (this.$route.params.id == -1) {
        return false;
      }
      this.activeKey = val;
    },
    nextFun(val) {
      if (val.insuranceAttachId) {
        this.id = val.insuranceAttachId;
      }
      this.activeKey++;
    },
    prevFun() {
      this.activeKey--;
    }
  }
};